export const POINT_OF_SALE_ID_COOKIE = 'point-of-sale-id'
export const PICKUP_POINT_OF_SALE_ID_COOKIE = 'pickup-point-of-sale-id'
export const PICKUP_POINT_OF_SALE_LOCAL_STORAGE_NAMESPACE = 'pickupPointOfSaleInfo'

/**
 * Minimum number of available points of sale required to display the postal code search input.
 * Below this threshold, filtering via search is considered unnecessary.
 */
export const MIN_POINTS_OF_SALE_FOR_POSTAL_CODE_SEARCH = 4
